module.exports = __webpack_public_path__ + "static/vid1-a95af86a15596ab022540d1e9adcc776.mp4";